import { FC, useContext, useRef, useState} from "react"
import { AgGridColumn, AgGridReact } from "ag-grid-react"
import '../../../../../ag-grid.css'
import '../../../../../ag-theme-alpine.css'
import { warning } from "../../../../../utils/notifications"
import { EditEnergiaModalDialog } from "./EditEnergiaModalDialog/EditEnergiaModalDialog"
import { defaultRenderer } from "../../../../../utils/helperFunctions"
import { UserContext } from "../../../../../Redux/UserContext"

export const EnergiaTableSimple:FC<any> = (props) => {

    const gridRef :any= useRef();

    const { data, setData, dataMASTER, simulated, original, saveLoading, scenarioBase } = props

    const [state] = useContext(UserContext)

    const [ visible, setVisible ] = useState<boolean>(false)

    const [ selectedCell, setSelectedCell ] = useState<any>()

    const [ selectedRow, setSelectedRow ] = useState<any>()

    const [ mode, setMode] = useState<string>("")

    const [ type, setType ] = useState<string>("PKM")

    const handleClose = () => {
        setSelectedCell(undefined)
        setSelectedRow(undefined)
        setVisible(false)
        setMode("")
    }

   

    const handleEditCellContentP = (params:any) => {
        let { colId } = params.column
        
        if(colId !== 'name_plant' && colId !== 'anio') {
            setType("P")
            let modo = colId.split("_")
            modo.slice(-1)[0] === 'a'? setMode("base") : setMode("comparision")
            if(modo.slice(-1)[0] === 'a') {
                if(simulated.scenario_base && !original.scenario_base) {
                    warning("No se puede editar un escenario que ya está simulado.")
                } else if(original.scenario_base && colId !== 'stock_minimo_a' && colId !== 'stock_maximo_a') {
                    warning("No se puede editar en el escenario original.")
                } else if(original.scenario_base) {
                    warning("No se puede editar el escenario original.")
                } else {
                    setSelectedCell(colId)
                    setSelectedRow(params.data)
                    setVisible(true)
                }
            } else {
                if(simulated.scenario_comparision && !original.scenario_comparision) {
                    warning("No se puede editar un escenario que ya está simulado.")
                } else if(original.scenario_comparision && colId !== 'stock_minimo_b' && colId !== 'stock_maximo_b') {
                    warning("No se puede editar en el escenario original.")
                } else if(original.scenario_comparision) {
                    warning("No se puede editar el escenario original.")
                } else {
                    setSelectedCell(colId)
                    setSelectedRow(params.data)
                    setVisible(true)
                }
            }
        }
        
        
    }

    const handleEditCellContentM = (params:any) => {
        let { colId } = params.column
        if(colId !== 'mes' && colId !== 'energia_a' && colId !== 'anio') {
            setType("M")
            let modo = colId.split("_")
            modo.slice(-1)[0] === 'a'? setMode("base") : setMode("comparision")
            if(modo.slice(-1)[0] === 'a') {
                if(simulated.scenario_base && !original.scenario_base) {
                    warning("No se puede editar un escenario que ya está simulado.")
                } else if(original.scenario_base && colId !== 'stock_minimo_a' && colId !== 'stock_maximo_a') {
                    warning("No se puede editar en el escenario original.")
                } else if(original.scenario_base) {
                    warning("No se puede editar el escenario original.")
                } else {
                    setSelectedCell(colId)
                    setSelectedRow(params.data)
                    setVisible(true)
                }
            } else {
                if(simulated.scenario_comparision && !original.scenario_comparision) {
                    warning("No se puede editar un escenario que ya está simulado.")
                } else if(original.scenario_comparision && colId !== 'stock_minimo_b' && colId !== 'stock_maximo_b') {
                    warning("No se puede editar en el escenario original.")
                } else if(original.scenario_comparision) {
                    warning("No se puede editar el escenario original.")
                } else {
                    setSelectedCell(colId)
                    setSelectedRow(params.data)
                    setVisible(true)
                }
            }
        }
        
        
    }

    const handleCellStylePEditable = (params:any) => {
        let original = dataMASTER.energy_plant_table.find((ori:any) => ori.id_plant === params.data.id_plant)?.[params.column.colId]
        if(original != params.value) {
            return {backgroundColor: 'orange', color: 'white', fontWeight:'bold',height:'100%',borderRight:'1px solid #dee2e6'}
        } else {
            return {backgroundColor: 'transparent',color: 'black',fontWeight:'normal',height:'100%',borderRight:'1px solid #dee2e6'}
        }   
    }

    const handleCellStyleMEditable = (params:any) => {
        let original = dataMASTER.energy_month_table.find((ori:any) => ori.mes === params.data.mes)?.[params.column.colId]
        if(original != params.value) {
            return {backgroundColor: 'orange', color: 'white', fontWeight:'bold',height:'100%',borderRight:'1px solid #dee2e6'}
        } else {
            return {backgroundColor: 'transparent',color: 'black',fontWeight:'normal',height:'100%',borderRight:'1px solid #dee2e6'}
        }   
    }

    const handleCellStyleP = (params:any) => {
        let original = dataMASTER.energy_plant_table.find((ori:any) => ori.id_plant === params.data.id_plant)?.[params.column.colId]
       
        if(original != params.value) {
            
            return {backgroundColor: 'orange', color: 'white', fontWeight:'bold',borderRight:'1px solid #dee2e6'}
        } else {
            return {backgroundColor: 'rgb(236, 236, 236)',color: 'black',fontWeight:'normal',borderRight:'1px solid #dee2e6'}
        } 
    }

    const handleCellStyleM = (params:any) => {
        let original = dataMASTER.energy_month_table.find((ori:any) => ori.mes === params.data.mes)?.[params.column.colId]
       
        if(original != params.value) {
            
            return {backgroundColor: 'orange', color: 'white', fontWeight:'bold',borderRight:'1px solid #dee2e6'}
        } else {
            return {backgroundColor: 'rgb(236, 236, 236)',color: 'black',fontWeight:'normal',borderRight:'1px solid #dee2e6'}
        } 
    }

    const monthCellRenderer = (params:any) => {
        return params.value.charAt(0).toUpperCase() + params.value.slice(1)
    }
    
 

    return (
        <div className="energiatable__wrapper">
            <EditEnergiaModalDialog
                    visible={visible}
                    setVisible={setVisible}
                    handleClose={handleClose}
                    selectedCell={selectedCell}
                    setSelectedCell={setSelectedCell}
                    selectedRow={selectedRow}
                    setSelectedRow={setSelectedRow}
                    mode={mode}
                    setMode={setMode}
                    data={data}
                    dataMASTER={dataMASTER}
                    setData={setData}
                    type={type}   
                />
            <div className="ag-theme-alpine" style={saveLoading? {display:'flex',flexDirection:'column', height:'100%', width: '44%',opacity:0.6 } : {display:'flex',flexDirection:'column', height:'100%', width: '44%' }}>
            {
                    saveLoading?
                        <div className="scenario__overlay-table"></div>
                        :
                        false
                }
                <AgGridReact
                    ref={gridRef}
                    headerHeight={30}
                    getRowHeight={() => 30}
                    onCellDoubleClicked={state?.rol_id !== undefined? [3,4].includes(state.rol_id) && !state.id_plants.includes(scenarioBase.id_plant) ? () => warning("No tienes permisos para realizar esta acción") : handleEditCellContentP : () => warning("No tienes permisos para realizar esta acción")}
                    rowData={data?.energy_plant_table}
                    enableCellTextSelection
                    >
                    <AgGridColumn sortable   suppressNavigable={true} flex={1} hide   headerName={"ID Planta"} field={"id_plant"}></AgGridColumn>
                    <AgGridColumn sortable cellStyle={handleCellStyleP} headerClass={"header-resize"}   suppressNavigable={true} flex={1}  headerName={"Planta"} field={"name_plant"}></AgGridColumn>

                    <AgGridColumn cellStyle={handleCellStylePEditable} headerClass={"header-resize"} sortable cellRenderer={defaultRenderer}  flex={1} suppressNavigable  headerName="Stock inicial" field="stock_inicial_a"></AgGridColumn>
                    
                    <AgGridColumn cellStyle={handleCellStylePEditable} headerClass={"header-resize"} sortable cellRenderer={defaultRenderer} flex={1} suppressNavigable  headerName="Stock mínimo" field="stock_minimo_a"></AgGridColumn>
                    
                    <AgGridColumn cellStyle={handleCellStylePEditable} headerClass={"header-resize"} sortable cellRenderer={defaultRenderer} flex={1} suppressNavigable  headerName="Stock máximo" field="stock_maximo_a"></AgGridColumn>
                        
    
                </AgGridReact>
            </div>
            <div className="ag-theme-alpine" style={saveLoading? {display:'flex',flexDirection:'column', height:'100%', width: '55%',opacity:0.6 } : {display:'flex',flexDirection:'column', height:'100%', width: '55%' }}>
            {
                    saveLoading?
                        <div className="scenario__overlay-table"></div>
                        :
                        false
                }
                <AgGridReact
                    ref={gridRef}
                    headerHeight={30}
                    getRowHeight={() => 30}
                    onCellDoubleClicked={state?.rol_id !== undefined? [3,4].includes(state.rol_id) && !state.id_plants.includes(scenarioBase.id_plant) ? () => warning("No tienes permisos para realizar esta acción") : handleEditCellContentM : () => warning("No tienes permisos para realizar esta acción")}
                    rowData={data?.energy_month_table.sort((a:any,b:any) => {
                        if (a.anio !== b.anio) {
                            return a.anio - b.anio;
                          }
                          // Si los años son iguales, ordena por mes
                          return a.id_mes - b.id_mes;
                    })}
                    enableCellTextSelection
                    >
                    <AgGridColumn sortable cellStyle={handleCellStyleM} headerClass={"header-resize"}   suppressNavigable={true} flex={1} hide   field={"id_mes"}></AgGridColumn>
                    <AgGridColumn sortable cellStyle={handleCellStyleM} headerClass={"header-resize"}   suppressNavigable={true} flex={1} cellRenderer={monthCellRenderer} headerName={"Mes"} field={"mes"}></AgGridColumn>
                    <AgGridColumn sortable cellStyle={handleCellStyleM} headerClass={"header-resize"}   suppressNavigable={true} flex={1}  headerName={"Año"} field={"anio"}></AgGridColumn>
                    <AgGridColumn cellStyle={handleCellStyleMEditable} headerClass={"header-resize"} sortable cellRenderer={defaultRenderer}  flex={1} suppressNavigable  headerName="Toneladas de herbáceo" field="toneladas_herbaceo_a"></AgGridColumn>
                        
                    <AgGridColumn cellStyle={handleCellStyleMEditable} headerClass={"header-resize"} sortable  cellRenderer={defaultRenderer}  flex={1} suppressNavigable  headerName="Toneladas de leñoso" field="toneladas_lenoso_a"></AgGridColumn>
                    
                    <AgGridColumn cellStyle={handleCellStyleM} headerClass={"header-resize"} sortable  cellRenderer={defaultRenderer} flex={1} suppressNavigable  headerName="Energía (MWh)" field="energia_a"></AgGridColumn>
                    
    
                </AgGridReact>
                
            </div>
        </div>
    )
}